import { useTranslation } from 'react-i18next';

const points = [
  { key: 'point1', icon: 'ri-map-pin-line' },
  { key: 'point2', icon: 'ri-flight-takeoff-line' },
  { key: 'point3', icon: 'ri-hand-heart-line' },
];

export default function TravelTrainingSection() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('corporate.travel.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('corporate.travel.title')}
          </h2>
          {String(t('corporate.travel.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto mb-5"></div>
          {String(t('corporate.travel.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">{__s}</p>))}
        </div>

        {/* Scene Images */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-14 max-w-[960px] mx-auto">
          <div className="relative h-56 md:h-72 overflow-hidden">
            <img
              src="/images/generated/corp-home-training-01.jpg"
              alt={t('corporate.travel.img1Alt')}
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="relative h-56 md:h-72 overflow-hidden">
            <img
              src="/images/generated/corp-home-training-02.jpg"
              alt={t('corporate.travel.img2Alt')}
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-[1100px] mx-auto">
          {points.map((p) => (
            <div
              key={p.key}
              className="flex flex-col items-start gap-4 p-6 bg-background-50 border border-background-200/60"
            >
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className={`${p.icon} text-accent-500 text-xl`}></i>
              </div>
              <h3 className="font-heading text-[16px] text-foreground-900 tracking-[0.04em]">
                {t(`corporate.travel.${p.key}.title`)}
              </h3>
              <p className="text-[14px] text-foreground-600 tracking-[0.03em] leading-relaxed">
                {t(`corporate.travel.${p.key}.desc`)}
              </p>
            </div>
          ))}
        </div>

        {String(t('corporate.travel.note')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[13px] text-foreground-500 tracking-[0.03em] leading-relaxed max-w-[650px] mx-auto text-center mt-10">{__s}</p>))}
      </div>
    </section>
  );
}
